import { get } from 'lodash'
import { required } from 'utils/validation'

export default function(values = {}, props) {
    const errors = {
        gopId: required(get(values, 'gopId'))
    }

    if (get(values, 'gopId')) {
        const dropdownSGOPs = get(props, 'dropdownSGOPs')

        if (dropdownSGOPs && dropdownSGOPs.length > 0) {
            errors.sgopId = required(get(values, 'sgopId'))
        }
    }
    return errors
}
